


















import { getCurrentUserProfileData } from '@/models/userProfile'
import { AxUser } from '@/types/AxUserType'
import { cecPaths } from '../cecSitePath'

    export default {
        data() {
            return {
            initialized: false as boolean,
            user: null as  AxUser,
            isLoggedIn: false as boolean,
            pagePath: cecPaths,
            }
        },
        async created(){

            if(this.$AxE2.isLoggedIn){
                await this.fetchCurrentUser()
                this.isLoggedIn = true
                console.log(this.isLoggedIn)
            }
            this.initialized = true
        },
        methods:{
            async fetchCurrentUser(){
                this.user = await getCurrentUserProfileData()
                console.log(this.user)
            },
        }
    }
